






























import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ppdwTooltip extends Vue {
    @Prop({ default: "" }) icon: string;
    @Prop({ default: null }) text: string;
    @Prop(Boolean) center: boolean;
    @Prop(Boolean) left: boolean;
    @Prop(Boolean) right: boolean;
    @Prop(Boolean) fullWidth: boolean;
    @Prop({ default: 260 }) maxWidth: number;
    // @Prop({ default: 0 }) pullRight: number;
    menu = false;
    parseProp(prop) {
        if (typeof prop === "boolean") return prop;
        else return true;
    }
    containerTop = 0;
    mounted() {
        let updateScroll = () => {
            let elem: HTMLElement = this.$slots.activator[0].elm as HTMLElement;
            this.containerTop = elem.getBoundingClientRect().y;
        };
        document.addEventListener("scroll", updateScroll);
        updateScroll();
    }
    get classList() {
        let classes = ["cell-tooltip"];
        if (this.parseProp(this.right)) classes.push("right");
        else if (this.parseProp(this.center)) classes.push("center");
        else classes.push("left");
        if (this.parseProp(this.fullWidth)) classes.push("full-width");
        return classes;
    }
}
